import { InjectionToken } from '@angular/core';
import { App } from '@blockframes/model';

export const APP = new InjectionToken<App>('Name of the app');